<div class="gauge-container">
  <canvas id="indicator-gauge"></canvas>
  <div class="legend">
    <p>
      <span class="expansion"></span>
      <small>{{ brLabels["indicator-legend-expansion"] }}</small>
    </p>
    <p class="mid">
      <span class="caution"></span>
      <small>{{ brLabels["indicator-legend-caution"] }}</small>
    </p>
    <p>
      <span class="recession"></span>
      <small>{{ brLabels["indicator-legend-recession"] }}</small>
    </p>
  </div>
  <p>
    {{ brLabels["indicator-as-of"] }}
    <strong>{{ asOfDate }}</strong>
  </p>
</div>
